module.exports = __webpack_public_path__ + "img/bay-resort-3.499052a9.jpg";